/* eslint-disable jsx-a11y/alt-text */
// import { CenterFocusStrongOutlined } from "@material-ui/icons";s
import React from "react";
import "./Product.css";
import StarIcon from "@material-ui/icons/Star";
import { useStateValue } from "../StateProvider";

function Product({id, title, image, price, rating, author, subtitle }) {

  const [{basket}, dispatch] = useStateValue();

  console.log("this is the basket >>> ", basket);

  const addToBasket = () => {
    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        id: id,
        title: title,
        image: image,
        price: price,
        rating: rating,
      },
    });
  };

  return (
		<div className="product">
			<div className="product-info">
				<p className="product-title">{title}</p>
				<p className="product-subtitle">{subtitle}</p>
				<p className="product-author">{author}</p>
				<div className="product-business">
					<div className="product-rating">
						{Array(rating)
							.fill()
							.map((_, i) => (
								<StarIcon className="star-icon" />
							))}
					</div>

					<p className="product_price">
						<h2>
							<i class="fa fa-rupee"></i> {price}
						</h2>
					</p>
				</div>
			</div>

			<img src={image}></img>

			<button class="cart-button" onClick={addToBasket}>
				<span class="add-to-cart">Add to cart</span>
			</button>
		</div>
	);
}

export default Product;
